module.exports = __webpack_public_path__ + "img/1_3_m.d14cc8f0.jpg";